import {JsonObject, JsonProperty} from "typescript-json-serializer";

@JsonObject()
export class SketchLabelOptionsPropertiesConfiguration {
    /**
     * Whether labels are shown next to each segment of the graphic being sketched.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-views-interactive-sketch-SketchLabelOptions.html#enabled)
     */
    @JsonProperty()
    declare enabled?: boolean;

    constructor() {}
}
